import { ky } from './ky';

export interface FileDto {
  id: number;
  url: string;
}

export default class FileService {

  /**
   * 파일 업로드
   * @param file 파일
   * @param onProgress 업로드 진행 상태 콜백
   */
  async upload(file: File, onProgress?: (progress: number) => void) {
    const formData = new FormData();

    formData.append('file', file);

    return await ky.post('v1/files', {
      body: formData,
      onUploadProgress: (progress: any) => {
        if (onProgress) {
          onProgress(progress.percent * 100);
        }
      }
    }).json() as FileDto;
  }

}

